<template>
  <div
      v-if="visible"
      :style="style"
      class="context-menu"
      @click.stop
  >
    <ul class="menu-list">
      <li
          v-if="(item.tab_codigo === '963' || item.tab_codigo === '964') && !item.pagamento"
          @click="emit('pagamento')"
      >
        <i class="bx bx-money icon success"></i>
        <span>Realizar Pagamento</span>
      </li>

      <li
          v-if="(item.tab_codigo === '963' || item.tab_codigo === '964') && !item.pagamento"
          @click="emit('baixa-manual')"
      >
        <i class="bx bx-downvote icon"></i>
        <span>Baixa Manual</span>
      </li>

      <li @click="emit('alterar-duam')">
        <i class="bx bx-edit icon primary"></i>
        <span>Alterar DUAM</span>
      </li>

      <li v-if="item.pagamento" @click="emit('print-comprovante')">
        <i class="bx bx-printer icon info"></i>
        <span>Comprovante</span>
      </li>

      <div class="divider"></div>

      <li @click="emit('detalhe')">
        <i class="bx bx-show-alt icon"></i>
        <span>Detalhes Duam {{item.dam_codigo}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    x: Number,
    y: Number,
    item: Object
  },
  computed: {
    style() {
      return {
        position: "fixed",
        top: this.y + "px",
        left: this.x + "px",
        zIndex: 9999
      };
    }
  },
  methods: {
    emit(event) {
      this.$emit(event, this.item);
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.context-menu {
  background: #ffffff;
  border-radius: 10px;
  min-width: 220px;
  padding: 6px 0;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  border: 1px solid #eee;
  animation: fadeIn 0.12s ease-out;
}

.menu-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.menu-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 14px;
  color: #2d2d2d;
  cursor: pointer;
  transition: background 0.15s ease;
}

.menu-list li:hover {
  background: #f5f7fa;
}

.icon {
  font-size: 16px;
  color: #6b7280;
}

.icon.primary {
  color: #3b82f6;
}

.icon.success {
  color: #16a34a;
}

.icon.info {
  color: #0ea5e9;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 6px 0;
}

/* animação leve */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.97);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>